;(function () {
  'use strict'

  angular.module('contrast.trace.events').constant('TRACE_EVENT_TYPE', {
    TAG: 'Tag'
  })
})()
